import React from 'react';
import { NavMenu, PageId } from './NavMenu';

interface DesktopNavMenuProps {
  isOpen: boolean;
  onClose: () => void;
  currentPage: PageId;
  onPageChange: (page: PageId) => void;
}

export const DesktopNavMenu: React.FC<DesktopNavMenuProps> = (props) => {
  return <NavMenu {...props} />;
};
